import {Navigate, Outlet} from 'react-router-dom'
import {REDIRECT_MAP} from '@/utilities/constants'
import {UserRoleE} from '@/types'
import {useMe} from '@/features/authentication/queries/useMe'

export const AgentRoute = () => {
    const {data: user, isLoading} = useMe()
    const roleOfUser = user?.type
    const allowableUsersRole = [UserRoleE.Agent]
    const isAdmitted = roleOfUser && allowableUsersRole.includes(roleOfUser)

    return isLoading || isAdmitted ? <Outlet /> : <Navigate to={roleOfUser ? REDIRECT_MAP[roleOfUser] : '/'} />
}
